module.exports = __webpack_public_path__ + "img/menu1_banner03.b652bd8b.png";